// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditSpecificationModalContent-deleteButton-c9rQ4 Button-button-paJ9a Link-link-RInnp"};